import { put, call, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { TimeSlot } from '../types'
import {
  CREATE_TIME_SLOT,
  CREATE_TIME_SLOT_FAIL,
  CREATE_TIME_SLOT_SUCCESS,
  CreateTimeSlotActionType
} from '../redux/timeSlotsReducer'

function* CreateTimeSlotFlow(action: CreateTimeSlotActionType): Generator<any, void, any> {
  try {
    const response: TimeSlot = yield call(apiCall, {
      endpoint: '/tutors/time_slots',
      method: 'POST',
      params: { time_slot: action.payload }
    })
    yield put(CREATE_TIME_SLOT_SUCCESS(response))
  } catch (error) {
    yield put(CREATE_TIME_SLOT_FAIL())
    console.log(error)
  }
}

export default function* CreateTimeSlotSaga(): Generator<any, void, any> {
  yield takeLatest([CREATE_TIME_SLOT], CreateTimeSlotFlow)
}
